// Phase 5 (web revival) — Stream D.
//
// The left-hand side of the editor: just an <img> that shows whatever
// preview blob URL we hand it, with a faint loading shroud while a new
// preview is in flight. The blob URL itself is owned by Edit.tsx — this
// component is a dumb consumer.

interface EditorPreviewProps {
  src: string | null;
  loading: boolean;
}

export function EditorPreview({ src, loading }: EditorPreviewProps) {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden bg-neutral-950">
      {src ? (
        <img
          src={src}
          alt="Edit preview"
          className="max-h-full max-w-full object-contain"
          draggable={false}
        />
      ) : (
        <p className="text-sm text-neutral-500">Loading preview…</p>
      )}
      {loading && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-neutral-950/40 backdrop-blur-[1px] transition-opacity">
          <div className="rounded-md bg-neutral-900/80 px-3 py-1.5 text-xs text-neutral-200 shadow-md">
            Rendering…
          </div>
        </div>
      )}
    </div>
  );
}
